import React from "react";
import "./Privacy.css";

function Privacy() {
  return (
    <main className="privacy-page">
      <div className="privacy-aurora privacy-aurora-one" />
      <div className="privacy-aurora privacy-aurora-two" />

      <div className="privacy-content">
        <header className="privacy-hero">
          <p className="privacy-tag">Trust and Transparency</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-lead">
            This policy explains how Drop Off Mtaani collects, uses, and protects
            personal information across our web and mobile services.
          </p>
          <div className="privacy-meta">
            <div className="privacy-meta-card">
              <span>Last updated</span>
              <strong>March 17, 2026</strong>
            </div>
            <div className="privacy-meta-card">
              <span>Applies to</span>
              <strong>Drop Off Mtaani platform</strong>
            </div>
            <div className="privacy-meta-card">
              <span>Contact</span>
              <strong>privacy@dropoffmtaani.com</strong>
            </div>
          </div>
        </header>

        <section className="privacy-summary">
          <div className="privacy-summary-card">
            <h3>What we collect</h3>
            <p>
              Account details, delivery information, location data for routing,
              payment confirmations, and service usage analytics.
            </p>
          </div>
          <div className="privacy-summary-card">
            <h3>Why we collect it</h3>
            <p>
              To complete deliveries, keep you informed, prevent fraud, and
              improve service reliability.
            </p>
          </div>
          <div className="privacy-summary-card">
            <h3>Your control</h3>
            <p>
              You can access, update, or delete your data and manage marketing
              preferences at any time.
            </p>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Scope</h2>
          <p>
            This policy applies to Drop Off Mtaani websites, apps, and related
            services. It does not cover third-party sites or services that may
            be linked from our platform.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information we collect</h2>
          <ul className="privacy-list">
            <li>Account data such as name, email, phone number, and profile details.</li>
            <li>Delivery details including pickup, drop-off, and recipient information.</li>
            <li>Location data to enable routing, tracking, and driver coordination.</li>
            <li>Payment and billing details processed through trusted payment partners.</li>
            <li>Support records when you contact us or submit feedback.</li>
            <li>Usage data like device, browser type, and activity on our services.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How we use your information</h2>
          <ul className="privacy-list">
            <li>Provide, operate, and maintain the delivery service.</li>
            <li>Process transactions and send order confirmations.</li>
            <li>Enable live tracking and route optimization.</li>
            <li>Respond to inquiries, resolve disputes, and offer customer support.</li>
            <li>Improve features, reliability, and safety across the platform.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How we share information</h2>
          <p>We share only what is needed to deliver our services.</p>
          <ul className="privacy-list">
            <li>With drivers and logistics partners to complete deliveries.</li>
            <li>With payment processors to handle transactions securely.</li>
            <li>With vendors who provide hosting, analytics, or customer support.</li>
            <li>When required by law or to protect rights, safety, and security.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Cookies and tracking</h2>
          <p>
            We use cookies and similar technologies to keep you signed in,
            remember preferences, and understand how the service is used. You
            can manage cookies through your browser settings.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Data retention</h2>
          <p>
            We retain personal data only for as long as necessary to provide our
            services, comply with legal obligations, and resolve disputes. Data
            that is no longer needed is deleted or anonymized.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Security</h2>
          <p>
            We use administrative, technical, and physical safeguards to protect
            your information. No system is completely secure, but we work
            continuously to prevent unauthorized access.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Your rights and choices</h2>
          <ul className="privacy-list">
            <li>Access or update your account information.</li>
            <li>Request a copy or deletion of your personal data.</li>
            <li>Opt out of marketing messages while still receiving service updates.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Children</h2>
          <p>
            Our services are not intended for children under 13. We do not
            knowingly collect data from children under 13.
          </p>
        </section>

        <section className="privacy-section privacy-callout">
          <h2>Changes to this policy</h2>
          <p>
            We may update this policy from time to time. When we do, we will
            update the date at the top of this page and post the revised policy.
          </p>
        </section>

        <footer className="privacy-footer">
          <h2>Contact us</h2>
          <p>
            Questions about privacy? Email us at{" "}
            <span className="privacy-email">privacy@dropoffmtaani.com</span>.
          </p>
          <p className="privacy-footer-note">
            By using Drop Off Mtaani, you agree to this privacy policy.
          </p>
        </footer>
      </div>
    </main>
  );
}

export default Privacy;
